import type { paths } from "@/api-schema";
import { useModelGenerationByUuidQuery } from "@/common/api/model-generation/use-model-generation-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { ModelGenerationFormFields } from "../_components/model-generation-form-fields";

interface ModelGenerationUpdateViewParams {
  uuid: string;
}

export function ModelGenerationUpdateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<ModelGenerationUpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/model-generation/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/model-generation/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useModelGenerationByUuidQuery}
      notFoundProps={{
        title: t("masterdata:ModelNotFound"),
        message: t("masterdata:ModelDoesNotExist"),
        description: t("masterdata:CheckModelIdOrContactSupport"),
        backTo: "~/masterdata/model-generation",
        backToLabel: t("masterdata:BackToModelOverview"),
      }}
    >
      <ModelGenerationUpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function ModelGenerationUpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:EditModel");
  const pageSubtitle = t("common:ReviewAndSaveChangesDescription");
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <ModelGenerationFormFields uuid={uuid} />
    </CenteredLayout>
  );
}
